import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bc0a738c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=bc0a738c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0a738c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc0a738c')) {
      api.createRecord('bc0a738c', component.options)
    } else {
      api.reload('bc0a738c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=bc0a738c&scoped=true&", function () {
      api.rerender('bc0a738c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BlockTokenListShow/index.vue"
export default component.exports